import SearchType from '@/enums/SearchType';

export default {
  methods: {
    trackSearchLoad(type = SearchType.GuidedSearch, version = '1.0') {
      const windowLocation = { ...window.location };
      delete windowLocation.assign;
      delete windowLocation.reload;
      delete windowLocation.replace;
      delete windowLocation.toString;

      this.$analytics.track({
        eventName: 'search_load',
        parent: 'search',
        child: 'start-search',
        type,
        version,
        windowLocation,
      });
    },
  },
};
